<template>
  <v-container>
    <v-row justify="center">
      <v-col class="text-center">
        <p
          class="rentpress-inherited-font-family
              primary--text
              text-h4
              font-weight-black
              "
        >
          {{ title }}
        </p>
        <p class="rentpress-inherited-font-family text-subtitle-1">
          {{ message }}
        </p>
        <p class="rentpress-inherited-font-family text-subtitle-1">
          For more information, please
          <a
            @click="navigateTo(contactLink)"
            :href="contactLink"
            class="primary--text"
          >
            Contact Us</a
          >.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="property">
        <p class="rentpress-inherited-font-family text-subtitle-1">
          Database columns
        </p>
        <v-list>
          <v-list-item
            v-for="(propertyData, propertyKey) in property"
            :key="propertyKey"
          >
            <div v-if="propertyKey != 'floorplans'">
              {{ propertyKey }} : {{ propertyData }}
            </div>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "rentpress-error",
  props: {
    message: String,
    title: String,
    options: Object,
    property: {}
  },
  methods: {
    navigateTo(newLocation) {
      window.location = "https://" + newLocation;
    }
  },
  computed: {
    contactLink() {
      return this.options.rentpress_application_link_section_url_contact
        ? this.options.rentpress_application_link_section_url_contact
        : window.location.host + "/contact";
    }
  }
};
</script>
